class Inquiry
{
  id: string;
  account_id: string;
  username: string;
  email: string;
  subject: string;
  body: string;
  posted_at: string;
  status: string;

  constructor() {
    this.id = '';
    this.account_id = '';
    this.username = '';
    this.email = '';
    this.subject = '';
    this.body = '';
    this.posted_at = '';
    this.status = '';
  }

  load(data: any) {
    this.id = data.id;
    this.account_id = data.account_id;
    this.username = data.username;
    this.email = data.email;
    this.subject = data.subject;
    this.body = data.body;
    this.posted_at = data.posted_at;
    this.status = data.status;
  }

  buildFormData(): FormData {
    const data = new FormData();

    data.append('id', this.id);
    data.append('account_id', this.account_id);
    data.append('username', this.username);
    data.append('email', this.email);
    data.append('subject', this.subject);
    data.append('body', this.body);
    data.append('posted_at', this.posted_at);
    data.append('status', this.status);

    return data;
  }
}

export default Inquiry;
